import { type FC } from "react";

import { pageUrl } from "../../../../utils/urls";

import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { Menu, MenuItem } from "mds/components/Menu";
import { CheckIcon, DotMenuVerticalIcon, UndoIcon } from "mds/icons";
import { markPageAssessmentsStatus } from "utils/page";

interface MarkAssessmentCompleteMenuProps {
  isMarkedComplete: boolean;
  isCourseAssessment?: boolean;
  pageId: string;
  pageTitle: string;
  sectionId: string;
  onChange: () => void;
}
export const MarkAssessmentCompleteMenu: FC<MarkAssessmentCompleteMenuProps> = ({
  isMarkedComplete,
  isCourseAssessment,
  pageId,
  pageTitle,
  sectionId,
  onChange,
}) => {
  return (
    <Menu
      align="end"
      menuButton={
        <Button kind="transparentSquareLegacy" size="xs">
          <DotMenuVerticalIcon />
        </Button>
      }
    >
      {isMarkedComplete ? (
        <MenuItem
          eventName={`${isCourseAssessment ? "Course" : "Home"} - Assessments / Undo mark as complete`}
          eventProps={{
            pageTitle,
            pageUrl: pageUrl(sectionId, pageId),
            pageId,
          }}
          onClick={async () => {
            await markPageAssessmentsStatus(pageId, false);
            onChange();
          }}
        >
          <IconText
            iconStart={<UndoIcon />}
            text={t("sidebar_options_menu.mark_as_complete_undo")}
          />
        </MenuItem>
      ) : (
        <MenuItem
          eventName={`${isCourseAssessment ? "Course" : "Home"} - Assessments / Mark as complete`}
          eventProps={{
            pageTitle,
            pageUrl: pageUrl(sectionId, pageId),
            pageId,
          }}
          onClick={async () => {
            await markPageAssessmentsStatus(pageId, true);
            onChange();
          }}
        >
          <IconText iconStart={<CheckIcon />} text={t("sidebar_options_menu.mark_as_complete")} />
        </MenuItem>
      )}
    </Menu>
  );
};
